import { createFileRoute } from '@tanstack/react-router';
import ReservationConfirmation from '../components/webdesigned/ReservationConfirmation';

export const Route = createFileRoute('/reservation-confirmation')({
  component: ReservationConfirmationRouteComponent,
});

function ReservationConfirmationRouteComponent() {
  const data = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('pendingReservation') : null;
  if (!data) return <div className="p-8 text-center">No reservation found</div>;
  const parsed = JSON.parse(data);
  return <ReservationConfirmation reservationId={parsed.reservationId} reservationData={parsed.reservationData} />;
}
